module.exports = __webpack_public_path__ + "static/media/Balanca-1.f0de49be.gif";